export default {"src":"/_next/static/media/google-news-icon.00b1bb26.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};